import { render, staticRenderFns } from "./ExtraScoresModal.vue?vue&type=template&id=3163e5f2&scoped=true&"
import script from "./ExtraScoresModal.vue?vue&type=script&lang=js&"
export * from "./ExtraScoresModal.vue?vue&type=script&lang=js&"
import style0 from "./ExtraScoresModal.vue?vue&type=style&index=0&id=3163e5f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3163e5f2",
  null
  
)

export default component.exports